import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  AvatarNode,
  Card,
  CountDownText,
  FallbackActionGroup,
  InvitationStepsButtonGroup,
} from '../../../components/Molecules';
import { getJOYAJOYLogoHorizontalLogoSloganForDarkBGImage } from '../../../constants/images';
import { getInvitationMessage } from '../../../constants/shareInvitationLink';
import useDeepLink from '../../../hooks/useDeeplink';
import { TranslationLocale } from '../../../i18n';
import {
  InvitationLink,
  UserInvitationType,
} from '../../../models/UserStore/Invitation';
import { useUserStore } from '../../../stores/UserStore';
import { getUiLocale } from '../../../utils/i18n';

type ReferralSharingTemplateProps = {
  invitationLink: InvitationLink;
};

export const ReferralSharingScreen = (props: ReferralSharingTemplateProps) => {
  const { invitationLink } = props;
  const [currentStep] = useState<'info' | 'register' | 'result'>('info');
  const [status] = useState<'loading' | 'loaded' | 'error'>('loaded');
  const { t, i18n } = useTranslation();

  const contentInviterUserId = invitationLink.userId;
  const contentInviterProfile = useUserStore
    .getState()
    .getProfile(contentInviterUserId);

  // const [form, setForm] = useState<{
  //   email: string;
  //   password?: string;
  //   agreeStatement: boolean;
  //   emailErrorMessage?: string;
  // }>({
  //   email: invitationLink?.email ?? '',
  //   password: undefined,
  //   agreeStatement: false,
  // });
  // const onEmailChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
  //   const validateResult = emailSchema.safeParse(event.target.value);

  //   setForm((s) => ({
  //     ...s,
  //     email: event.target.value,
  //     emailErrorMessage: validateResult.success
  //       ? undefined
  //       : 'Please enter a valid email address.',
  //   }));
  // }, []);

  const expiryAt = invitationLink.expiredAt;

  // const submit = useCallback(async () => {
  //   try {
  //     setStatus('loading');
  //     const response = await register({
  //       uiTheme: Theme.Auto,
  //       interfaceLocale: getUiLocale(i18n.language as TranslationLocale),
  //       email: form.email,
  //       userCode: invitationLink?.userCode,
  //     });

  //     if (response.result == RegisterResult.Success) {
  //       const password = response.password;
  //       if (password) {
  //         setForm((s) => ({ ...s, password: password }));
  //       }
  //       setStatus('loaded');
  //       setCurrentStep('result');
  //     } else {
  //       toast(t('There is something wrong.'), AppToastErrorOption);
  //       setStatus('error');
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, [form.email, i18n.language, invitationLink?.userCode, t]);

  // const onClick = () => {
  //   submit().catch((error) => {
  //     console.error(error);
  //   });
  // };

  // const onPressCopy = () => {
  //   copy(form.password ?? '');
  //   toast(t('Password is copied.'), {
  //     ...AppToastInfoOption,
  //     id: 'clipboard',
  //   });
  // };
  const onPresOpenAppElseAppStore = useDeepLink(
    `joyajoyapp://user-invite?invitationLinkId=${invitationLink.invitationLinkId}`,
  );

  const bannerSource = getJOYAJOYLogoHorizontalLogoSloganForDarkBGImage(
    getUiLocale(i18n.language as TranslationLocale),
  );

  if (status == 'loading')
    return (
      <>
        <div
          className="flex flex-col justify-center items-center"
          style={{ flex: 1 }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ color: '#05656B' }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </>
    );

  if (currentStep == 'info') {
    return (
      <>
        <div
          className="flex flex-col share-content"
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <Card style={{ width: '100%', maxWidth: '480px', padding: '0 1rem' }}>
            {contentInviterProfile ? (
              <>
                <AvatarNode profile={contentInviterProfile} size={80} />
                <p
                  className="text-lg text-cyan-800"
                  style={{ textAlign: 'center', padding: '1rem' }}
                >
                  <span className="font-bold">
                    {contentInviterProfile.name}{' '}
                  </span>
                  {t(getInvitationMessage(UserInvitationType.Referral))}
                </p>
              </>
            ) : null}

            <img
              src={bannerSource}
              style={{
                width: '100%',
                backgroundColor: '#00A698',
                padding: '1.5rem 1rem',
                borderRadius: '1rem',
              }}
            />

            <div
              className="flex flex-col items-center w-full"
              style={{ padding: '0.25rem', marginTop: '16px' }}
            >
              {/* <p className="text-lg font-bold">
                {t('Click OK to view details')}
              </p>
              <TextButton
                text={t('OK')}
                size={TextButtonSize.Large}
                variant={TextButtonVariant.Cyan}
                onClick={onPresOpenAppElseAppStore}
              /> */}
              <InvitationStepsButtonGroup
                onPressAccept={onPresOpenAppElseAppStore}
              />

              <CountDownText
                timestamp={expiryAt.getTime()}
                label={t('Expiry: ')}
                className="text-sm font-bold text-red-550"
              />
              <FallbackActionGroup />
            </div>
          </Card>
        </div>
      </>
    );
  }
  if (currentStep == 'register') {
    return <></>;
  }
  if (currentStep == 'result') {
    return <></>;
  }
  return <></>;
};
